import type { FC } from 'react';
import { InputField } from '../input-field/InputField';

interface Props {
  startTime: string;
  endTime: string;
  onStartTimeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEndTimeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CustomRangeInputs: FC<Props> = ({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
}) => {
  return (
    <div className="grid">
      {/* Start Time */}
      <div className="space-y-2">
        <label className="text-onlight-text-2 dark:text-ondark-text-2 flex items-center gap-2 text-xs font-semibold">
          From
        </label>
        <InputField
          type="datetime-local"
          value={startTime}
          onChange={onStartTimeChange}
          placeholder="Start time"
        />
      </div>

      {/* End Time */}
      <div className="mt-2 space-y-2">
        <label className="text-onlight-text-2 dark:text-ondark-text-2 flex items-center gap-2 text-xs font-semibold">
          To
        </label>
        <InputField
          type="datetime-local"
          value={endTime}
          onChange={onEndTimeChange}
          placeholder="End time"
        />
      </div>
    </div>
  );
};
